import React from "react";
// COMPONENTS
import MonitoringLiftStatusView from "./MonitoringLiftStatusView";
// INTERFACES
import { BankInterface } from "../../../interfaces/Bank.interface";
import { LiftInterface } from "../../../interfaces/Lift.interface";
// UTILS
import { hasMixedDoorConfig } from "../../../utils/bitmaskToIcon";

function MonitoringStatusView({
  bank,
  serverId,
  channelId,
}: {
  bank: BankInterface;
  serverId: string;
  channelId: string;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div style={{ padding: "10px" }}>
      <div className={` generalStyles__flexCenter`}>
        {(bank.lifts ?? []).map((lift: LiftInterface) => (
          <div key={String(lift.id)}>
            <MonitoringLiftStatusView
              lift={lift}
              bank={bank}
              serverId={serverId}
              channelId={channelId}
              bankHasMixedDoors={hasMixedDoorConfig(lift.liftFloors)}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default React.memo(MonitoringStatusView);
